import { InjectionToken } from '@angular/core';

export const PG_INPUT_VALUE_ACCESSOR = new InjectionToken<{ value: any }>(
  'PG_INPUT_VALUE_ACCESSOR'
);
